/**
 * Encode a single URL path segment.
 *
 * Do not encode a whole URL with this — only the interpolated piece, so `/`,
 * `?`, `#` and `%` cannot change which route is hit.
 */
export function encodePathSegment(value: string): string {
  return encodeURIComponent(value);
}
